import { Notyf } from 'notyf';

const { id, dataset } = document.body;
const { flashNotice, flashAlert } = dataset;

// check for flash
const notyf = new Notyf({
  duration: 10000,
  position: {
    x: 'right',
    y: 'top',
  },
  dismissible: true,
});
window.notyf = notyf;

if (flashAlert) {
  notyf.error(flashAlert);
} else if (flashNotice) {
  notyf.success(flashNotice);
}

if (id === 'home-index') {
  import('../js/views/home/index');
} else if (id === 'dpez_dealers-index') {
  import('../js/views/dpez_dealers/index');
} else if (id === 'dpez_dealers-kpi') {
  import('../js/views/dpez_dealers/kpi');
} else if (id === 'students-verify') {
  import('../js/views/students/verify');
} else if (id.startsWith('admin-')) {
  import('../js/views/admin/phone-formatter');
}


// Profile Dropdown
const profileMenuLink = document.getElementById('profile-menu-link');
const profileDropdown = document.getElementById('profile-menu-dropdown');

if (profileMenuLink && profileDropdown) {
  profileMenuLink.addEventListener('click', (e) => {
    // e.preventDefault();
    profileDropdown.classList.toggle('show');
  });
}
